import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressBarComponent } from '../../cross-team-shared/components/progress-bar/progress-bar.component';
import { SharedModule as UrsaSharedModule } from '../../shared/shared.module';
import { CategorizationContainerComponent } from '../categorization/views/categorization-container/categorization-container.component';
import { GenAiContainerComponent } from '../gen-ai/views/gen-ai-container/gen-ai-container.component';
import { H3mlModule } from '../h3ml/h3ml.module';
import { AutoSaveFailModalComponent } from './auto-save-fail-modal/auto-save-fail-modal.component';
import { LastSavedBadgeComponent } from './last-saved-badge/last-saved-badge.component';
import { ObjectlessLastSavedBadgeComponent } from './last-saved-badge/objectless-last-saved-badge.component';
import { MultiTabsOpenedModalComponent } from './multi-tabs-opened-modal/multi-tabs-opened-modal.component';
import { PauseTaskButtonComponent } from './pause-task-button/pause-task-button.component';
import { ProductionWorkspaceHeaderComponent } from './production-workspace-header/production-workspace-header.component';
import { ProductionWorkspaceHostComponent } from './production-workspace-host.component';
import { ProductionWorkspaceNavbarComponent } from './production-workspace-navbar/production-workspace-navbar.component';
import { ProductionWorkspaceComponent } from './production-workspace.component';
import { RejectionReasonsComponent } from './rejection-reasons/rejection-reasons.component';
import { StopWorkButtonComponent } from './stop-work-button/stop-work-button.component';
import { SubmitTaskDialogComponent } from './submit-task-dialog/submit-task-dialog.component';
import { TaskCommentComponent } from './task-comment/task-comment.component';
import { PauseTaskDialogComponent } from './task-paused-modal/pause-task-dialog.component';
import { TimerBadgeComponent } from './timer-badge/timer-badge.component';
import { TrainingToolsComponent } from './training-tools/training-tools.component';

@NgModule({
  imports: [
    CommonModule,
    GenAiContainerComponent,
    CategorizationContainerComponent,
    H3mlModule,
    UrsaSharedModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatProgressBarModule,
    ProgressBarComponent,
  ],
  declarations: [
    ProductionWorkspaceComponent,
    ProductionWorkspaceHostComponent,
    RejectionReasonsComponent,
    TaskCommentComponent,
    ObjectlessLastSavedBadgeComponent,
    ProductionWorkspaceNavbarComponent,
    TimerBadgeComponent,
    AutoSaveFailModalComponent,
    PauseTaskDialogComponent,
    PauseTaskButtonComponent,
    MultiTabsOpenedModalComponent,
    StopWorkButtonComponent,
    TrainingToolsComponent,
    ProductionWorkspaceHeaderComponent,
    LastSavedBadgeComponent,
    SubmitTaskDialogComponent,
  ],
  exports: [ProductionWorkspaceComponent, ProductionWorkspaceHostComponent],
})
export class ProductionWorkspaceModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    customElements.define(
      'ursa-production-workspace',
      createCustomElement(ProductionWorkspaceHostComponent, {
        injector: this.injector,
      }),
    );
  }
}
